module.exports = __webpack_public_path__ + "img/roll-744.7a9cdd01.png";